import { useState } from 'react';
import { LocationTracker } from '@/components/flexhelper/location/location-tracker';
import { MapView } from '@/components/tracking/map-view';
import { useToast } from '@/hooks/use-toast';

export function HelperLocationPage() {
  const [currentLocation, setCurrentLocation] = useState<GeolocationPosition | null>(null);
  const { toast } = useToast();

  const handleLocationUpdate = (position: GeolocationPosition) => {
    setCurrentLocation(position);
    // Here you would make an API call to update the location
    console.log('Location updated:', {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
      accuracy: position.coords.accuracy,
    });
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold tracking-tight">Location Tracking</h1>
      
      <div className="grid gap-6 md:grid-cols-[1fr_300px]">
        <MapView
          center={currentLocation ? {
            lat: currentLocation.coords.latitude,
            lng: currentLocation.coords.longitude,
          } : undefined}
          markers={currentLocation ? [{
            position: {
              lat: currentLocation.coords.latitude,
              lng: currentLocation.coords.longitude,
            },
            title: 'Current Location',
          }] : []}
        />
        
        <LocationTracker
          helper={{
            id: '1',
            name: 'Helper',
            status: 'available',
            currentLocation: currentLocation ? {
              lat: currentLocation.coords.latitude,
              lng: currentLocation.coords.longitude,
              accuracy: currentLocation.coords.accuracy,
              timestamp: currentLocation.timestamp.toString(),
            } : undefined,
          }}
          onLocationUpdate={handleLocationUpdate}
        />
      </div>
    </div>
  );
}